module.exports = __webpack_public_path__ + "img/pageSpeciaux.acdea5fd.png";